import React, { useEffect, useState } from 'react'
import PageHeader from '../../shared/page-header/PageHeader';
import SKAlerts, { CreateAlert } from "../../shared/common-alerts/SKAlerts";
import { getStorageValues } from '../../shared/CommonFunctions';
import { getModulePermissions } from '../../utils/permissionHelper';
import { exportToExcel, exportToPDF } from '../../utils/downloadExportedFiles';
import SalesRegisterModal from './SalesRegisterModal';
import SalesRegisterGrid from './SalesRegisterGrid';
import { fetchSalesRegisterList, saveSalesRegister, fetchSalesRegisterById, deleteSalesRegister } from '../../utils/salesRegisterApi';
import { logAuditEvent } from '../../utils/auditLogger';

function SalesRegisterMain(props) {
  const [salesRegisters, setSalesRegisters] = useState([]);
  const [modalIsOpen, setIsOpen] = React.useState(false);
  const [alert, setAlert] = useState(null);
  const [getUserModulePermission, setUserModulePermission] = React.useState([]);
  const [userAction, setUserAction] = useState('Add');
  const [selectedRow, setSelectedRow] = useState(null);
  const moduleName = props.Module || 'Sales Register';
  
  useEffect(() => {
    const modulePermissions = getModulePermissions(props.Module);
    setUserModulePermission(modulePermissions ? modulePermissions : []);
    fetchSalesRegisters();
  }, [props.Module]);

  useEffect(() => {
    logAuditEvent(moduleName, 'Accessed Module', 'Accessed Sales Register');
  }, [moduleName]);

  function openAddModal() {
    setUserAction('Add');
    setSelectedRow(null);
    setIsOpen(true);
    logAuditEvent(moduleName, 'Add Button Click', 'Opened add sales register modal');
  }
  async function openEditModal(row) {
    setUserAction('Edit');
    const hydrated = await hydrateSalesRegister(row);
    setSelectedRow(hydrated);
    setIsOpen(true);
  }
  async function openViewModal(row) {
    setUserAction('View');
    const hydrated = await hydrateSalesRegister(row);
    setSelectedRow(hydrated);
    setIsOpen(true);
  }
  async function openDeleteModal(row) {
    setUserAction('Delete');
    setSelectedRow(row);
    setIsOpen(true);
  }
  function closeModal() {
    setIsOpen(false);
  }

  async function onSubmit(e, data) {
    const actionName = e?.target?.name;
    if (actionName === 'Delete') {
      try {
        const payload = {
          SalesRegisterId: data?.SalesRegisterId,
          UserId: getStorageValues('userId')
        };
        const response = await deleteSalesRegister(payload);
        const spResult = response?.data;
        if (spResult && Number(spResult.success) === 0) {
          CreateAlert(spResult.message || 'Error', 'Error', setAlert);
          return;
        }
        CreateAlert('Sales Register deleted successfully!!', 'Success', setAlert);
        await fetchSalesRegisters();
        closeModal();
      } catch (error) {
        console.log(error);
        CreateAlert('Error deleting sales register.', 'Error', setAlert);
      }
      return;
    }

    if (!data || !data.CustomerName || !String(data.CustomerName).trim()) {
      CreateAlert('Customer Name is required!!', 'Warning', setAlert);
      return;
    }

    try {
      const payload = {
        SalesRegisterId: actionName === 'Edit' ? selectedRow?.SalesRegisterId : null,
        EnquiryId: data.EnquiryId || null,
        CustomerName: data.CustomerName,
        MobileNumber: data.MobileNumber,
        EmailId: data.EmailId,
        Remarks: data.Remarks,
        SalesDate: data.SalesDate,
        // send all details to preserve rows even if selection state is lost
        SalesRegisterDetails: data.SalesRegisterDetails || [],
        UserId: getStorageValues('userId')
      };
      const response = await saveSalesRegister(payload);
      const spResult = response?.data;
      if (spResult && Number(spResult.success) === 0) {
        CreateAlert(spResult.message || 'Error', 'Error', setAlert);
        return;
      }
      CreateAlert(spResult?.message || 'Saved', 'Success', setAlert);
      await fetchSalesRegisters();
      closeModal();
    } catch (error) {
      console.log(error);
      CreateAlert('Error saving sales register.', 'Error', setAlert);
    }
  }

  const fetchSalesRegisters = async () => {
    try {
      const rows = await fetchSalesRegisterList({ userId: getStorageValues('userId') });
      setSalesRegisters(rows);
    } catch (error) {
      console.log(error);
    }
  };

  const hydrateSalesRegister = async (row) => {
    if (!row?.SalesRegisterId) return row;
    try {
      const data = await fetchSalesRegisterById({ salesRegisterId: row.SalesRegisterId });
      const header = data?.header || row;
      const details = (data?.details || []).map(d => ({ ...d, Selected: true }));
      return { ...header, SalesRegisterDetails: details };
    } catch (err) {
      console.log(err);
      return row;
    }
  };

  const handleExportExcel = () => {
    const columns = [
      { name: "Customer Name", selector: "CustomerName" },
      { name: "Mobile Number", selector: "MobileNumber" },
      { name: "Enquire For", selector: "EnquireFor" },
      { name: "Sales Date", selector: "SalesDate" },
    ];
    exportToExcel("SalesRegister", columns, salesRegisters);
  };
  
  const handleExportPDF = () => {
    const columns = [
      { name: "Customer Name", selector: "CustomerName" },
      { name: "Mobile Number", selector: "MobileNumber" },
      { name: "Enquire For", selector: "EnquireFor" },
      { name: "Sales Date", selector: "SalesDate" },
    ];
    exportToPDF("SalesRegister", columns, salesRegisters);
  };
  return (
    <>
      <SKAlerts alert={alert} />
      <PageHeader
        displayModule={props.Module}
        onModelOpen={openAddModal} 
        onRefresh={fetchSalesRegisters}
        showPDF={true}
        showExcel={true}
        showPrint={false}
        showRefresh={true}
        onExcelExport={handleExportExcel}
        onPdfExport={handleExportPDF}
        showAddButton={getUserModulePermission.AddModule === 1 ? true : false}
      />
      <SalesRegisterGrid
        salesRegisters={salesRegisters}
        onAdd={openAddModal}
        onView={openViewModal}
        onEdit={openEditModal}
        onDelete={openDeleteModal}
        UserPermissions={getUserModulePermission}
        moduleName={moduleName}
      />
      <SalesRegisterModal
        show={modalIsOpen}
        UserAction={userAction}
        onClose={closeModal}
        onSubmit={onSubmit}
        selectedRow={selectedRow}
        moduleName ={props.Module}
      />
    </>
  )
}

export default SalesRegisterMain